var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(-43 -1986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M16.168,13.918a10.1,10.1,0,0,0-2.11-1.412c-.632-.3-.864-.3-1.312.025-.373.269-.614.52-1.042.426a6.218,6.218,0,0,1-2.094-1.55A6.174,6.174,0,0,1,8.06,9.313c-.091-.432.16-.67.426-1.042.322-.448.332-.679.025-1.312A9.9,9.9,0,0,0,7.1,4.849c-.46-.46-.563-.36-.817-.269a4.649,4.649,0,0,0-.748.4,2.257,2.257,0,0,0-.9.949c-.178.385-.385,1.1.667,2.974A16.594,16.594,0,0,0,8.22,12.791h0l0,0,0,0h0a16.659,16.659,0,0,0,3.891,2.918c1.872,1.052,2.589.845,2.974.667a2.219,2.219,0,0,0,.949-.9,4.649,4.649,0,0,0,.4-.748C16.528,14.481,16.631,14.378,16.168,13.918Z",
    transform: "translate(44.269 1987.369)",
    fill: "none",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    transform: "translate(43 1986)",
    fill: "none",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 12,
    rx: 11.5,
    ry: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 12,
    rx: 11.15,
    ry: 11.65,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.680eff0b0866d19f870775c41c92b507.svg";
export { ForwardRef as ReactComponent };